<div *ngIf="initialised">
    <div class="d-flex flex-wrap"  *ngIf="showBaseScreen">
        <div class="col-12 col-md-4">
            <h2>Pay by arrangement.</h2>
        </div>
        <div class="col-12 col-md">
            <form class="k-form" #wizardForm="ngForm" novalidate>
                <h4>Select debts to be paid</h4>
                <div class="d-flex flex-wrap">
                    <div class="col-12" [ngClass]="{'col-md-auto me-2': !isCollexusVersion()}" *ngFor="let account of getDebtAccounts()">
                        <input type="checkbox" [id]="'accountSelect' + account.accountId" kendoCheckBox [checked]="isDebtAccountSelected(account.accountId)"
                            (change)="toggleDebtAccount(account.accountId)" />
                        <kendo-label
                          class="k-checkbox-label"
                          [for]="'accountSelect' + account.accountId"
                          [text]="getDebtAccountDescription(account)">
                        </kendo-label>
                    </div>
                </div>
                <p>
                    <span class="me-2 bold">Total: {{getSelectedTotal()}}</span>
                    <span *ngIf="isPaymentAmountInMethodCurrencyVisible()" class="bold">{{ getTotalAmountInMethodCurrency() | async }}</span>
                </p>
                
                <hr/>
                
                <h4>Payment method</h4>
                <div *ngIf="isCountrySelectVisible()" class="d-flex flex-column mb-2">
                    <kendo-label text="Where are you paying from?">
                        <span class="required">*</span>
                    </kendo-label>
                    <kendo-buttongroup selection="single" class="d-flex flex-wrap">
                        <button *ngFor="let country of getPaymentCountries()" kendoButton class="col-12 col-md-auto me-2" [toggleable]="true"
                            (click)="setPaymentCountry(country)" [selected]="isCountrySelected(country)">
                            {{country}}
                        </button>
                    </kendo-buttongroup>
                </div>
                <div class="d-flex flex-column">
                    <kendo-label text="How do you wish to pay?">
                        <span class="required">*</span>
                    </kendo-label>
                    <kendo-buttongroup selection="single" class="d-flex flex-wrap">
                        <button *ngFor="let paymentMethod of getPaymentMethods()" kendoButton class="col-12 col-md-auto me-2" [toggleable]="true"
                            (click)="setPaymentMethod(paymentMethod)" [selected]="isPaymentMethodSelected(paymentMethod)">
                            {{paymentMethod.label}}
                        </button>
                    </kendo-buttongroup>
                </div>
                
                <hr/>
        
                <h4>Payment Plan</h4>
                <form class="k-form" #paymentPlanForm="ngForm" novalidate>
                    <div class="d-flex flex-wrap">
                        <div class="col-12 mb-3">
                            <kendo-label [for]="paymentAmount" text="Amount">
                                <span class="required">*</span>
                            </kendo-label>
                            <div class="d-flex align-items-center">
                                <span class="bold">$&nbsp;</span>
                                <kendo-numerictextbox class="input-payment-page" #paymentAmount name="paymentAmount" [(ngModel)]="paymentArrangement.regularPaymentAmount"
                                    [min]="0" placeholder="How much?" [spinners]="false" [required]="true">
                                </kendo-numerictextbox>
                                <span class="bold">&nbsp;&nbsp;{{getSelectedPaymentMethodCurrency()}}</span>
                            </div>
                        </div>
                        <div class="col-12">
                            <kendo-label [for]="startDate" text="Starting on">
                                <span class="required">*</span>
                            </kendo-label>
                            <kendo-datepicker #startDate name="startDate" class="input-payment-page" [(ngModel)]="paymentArrangement.regularPaymentStartDate"
                                placeholder="Starting date" [format]="'dd/MM/yyyy'" [required]="true">
                            </kendo-datepicker>
                        </div>
                    </div>
                </form>
                
                <hr/>
        
                <h4>Frequency</h4>
                <kendo-dropdownlist class="input-payment-page" [(value)]="paymentArrangement.regularPaymentFrequencyPeriod" [data]="getPaymentFrequencyPeriods()">
                </kendo-dropdownlist>
                
                <hr class="mb-4" />
                
                <!-- Mobile button -->
                <button kendoButton class="d-inline-block d-md-none button-primary" [disabled]="isNextDisabled() || !wizardForm.valid" (click)="onNextClick()">Next</button>
                <button kendoButton class="button-previous me-2" [routerLink]="['/']">Previous</button>
                <!-- Desktop button -->
                <button kendoButton class="d-none d-md-inline-block button-primary" [disabled]="isNextDisabled() || !wizardForm.valid" (click)="onNextClick()">Next</button>
            </form>
        </div>
    </div>

    <app-form-wizard *ngIf="showWizardScreen" [formValues]="formValues" [template]="formWizardTemplate" (actionButtonClick)="formWizardActionHandler($event)"></app-form-wizard>

    <div *ngIf="showConfirmScreen" class="d-flex flex-wrap">
        <div class="col-12 col-md-4">
            <h2>{{getConfirmHeading()}}</h2>
        </div>
        <div class="col-12 col-md">
            <div class="confirmation-section confirmation-section-hide-border">
                <div class="section-title" style="border-bottom: none;">Debt total being paid</div>
                <div class="section-detail-wrapper">
                    <div class="section-detail-value">
                        {{getConfirmDebts()}}
                    </div>
                </div>
            </div>

            <div class="confirmation-section confirmation-section-hide-border">
                <div class="section-title" style="border-bottom: none;">Total:</div>
                <div class="section-detail-wrapper">
                    <div class="section-detail-value">
                        {{getConfirmTotal()}}
                    </div>
                </div>
            </div>

            <div [ngSwitch]="selectedPaymentMethod">
                <div *ngSwitchCase="'DD'" class="confirmation-section">
                    <div class="section-title">Payment method</div>
                    <div class="section-detail-wrapper">
                        <div class="section-detail-value">
                            Direct debit<br>Account name: {{formValues.bdAccountName}}<br>Account number: {{formValues.bdAccountNumber}}
                        </div>
                    </div>    
                </div>
                <app-manual-summary *ngSwitchCase="'MANUAL'" [summary]="paymentPlanSummary"></app-manual-summary>
                <app-bpay-summary *ngSwitchCase="'BPAY'" [summary]="paymentPlanSummary"></app-bpay-summary>
            </div>

            <div class="confirmation-section">
                <div class="section-title">Plan summary</div>
                <div class="section-detail-wrapper">
                    <div class="section-detail-value">
                        Amount: {{getPlanSummaryAmount()}}<br>Frequency: {{paymentArrangement.regularPaymentFrequencyPeriod}}<br>Starting on: {{getStartDateFormatted()}}
                    </div>
                </div>
            </div>

            <div class="d-block d-md-flex mt-2">
                <!-- Mobile button -->
                <button kendoButton class="d-inline-block d-md-none button-primary" (click)="onConfirmNextButtonClick()">
                    Confirm
                </button>
                <button kendoButton class="button-previous me-2" (click)="onConfirmPreviousButtonClick()">
                    Previous
                </button>
                <!-- Desktop button -->
                <button kendoButton class="d-none d-md-inline-block button-primary" (click)="onConfirmNextButtonClick()">
                    Confirm
                </button>
            </div>
        </div>
</div>
